import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
/**
 * A number that counts up to its value when it first appears.
 *
 * The podium scores are the payoff of the whole page, and a number that is
 * simply present reads as data. Counting up gives it a moment of arrival —
 * small, but it is the difference between a table and a result.
 *
 * Respects `prefers-reduced-motion`: anyone who has asked for less movement
 * gets the final number immediately.
 */
export default class CountUp extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "displayed", 0);
    _defineProperty(this, "frame", void 0);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.start();
  }
  onupdate(vnode) {
    super.onupdate(vnode);

    // Switching metric or period replaces the value; count to the new one
    // rather than leaving the old total on screen.
    if (this.displayed !== this.attrs.value && !this.frame) {
      this.start();
    }
  }
  onremove(vnode) {
    super.onremove(vnode);
    if (this.frame) cancelAnimationFrame(this.frame);
  }
  start() {
    var _window$matchMedia, _window, _this$attrs$duration;
    const target = this.attrs.value || 0;
    if (typeof window === 'undefined' || (_window$matchMedia = (_window = window).matchMedia) != null && _window$matchMedia.call(_window, '(prefers-reduced-motion: reduce)').matches) {
      this.displayed = target;
      return;
    }
    const duration = (_this$attrs$duration = this.attrs.duration) != null ? _this$attrs$duration : 700;
    const from = this.displayed;
    const started = performance.now();
    const step = now => {
      const progress = Math.min(1, (now - started) / duration);

      // Ease out, so it decelerates into the final figure instead of
      // stopping dead.
      const eased = 1 - Math.pow(1 - progress, 3);
      this.displayed = Math.round(from + (target - from) * eased);
      m.redraw();
      if (progress < 1) {
        this.frame = requestAnimationFrame(step);
      } else {
        this.frame = undefined;
      }
    };
    this.frame = requestAnimationFrame(step);
  }
  view() {
    return m("span", {
      className: "CountUp"
    }, this.displayed.toLocaleString());
  }
}
flarum.reg.add('fof-gamification', 'forum/components/CountUp', CountUp);